// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"70254d0a","750":"a8560254"}[chunkId] + ".chunk.css";
};